module.exports = __webpack_public_path__ + "img/concept.2d1a76d7.png";